<template>
  <div class="loading_container" v-if="loading">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only"></span>
    </div>
  </div>

  <div class="main" v-else>
    <!-- Side Navbar -->
    <SideBar />
    <!-- Body-Content -->
    <div class="body-content">
      <!-- Top Navbar -->
      <TopBar />
      <!-- Body -->
      <div class="container-fluid body-container">
        <!-- Course exists and has active classes -->
        <div v-if="course !== null">
          <!-- Class doesn't exist in the course -->
          <div class="center-block" v-if="classObj === null">
            <div>
              <div class="alert alert-danger mb-0 text-center">
                A aula que você tentou acessar não está disponível.
                <p class="text-center">
                  <a :href="'/curso/' + course.id" class="btn mt-2">
                    <i class="fa fa-arrow-left" /> Voltar para o curso</a
                  >
                </p>
              </div>
            </div>
          </div>
          <!-- Class exists in the course and user has access to it -->
          <div v-else-if="classObj.available">
            <div
              class="alert alert-warning mb-3 text-center under-review"
              v-if="classObj.locked"
            >
              <i class="fa-solid fa-lock"></i>
              <span>
                Este conteúdo ficará disponível em
                <strong>{{ formatDuration(classObj.remainingSeconds) }}</strong
                >.</span
              >
            </div>

            <!-- Fixme: reintroduce after launch -->
            <div
              v-else-if="1 == 0"
              class="alert mb-3 mt-4"
              :class="{
                'alert-info': courseProgress === 100,
                'alert-warning': courseProgress < 100,
              }"
            >
              <div class="text-center" v-if="courseProgress === 100">
                <strong>Parabéns! Você completou este curso!</strong><br />
                Seu certificado já está disponível!
              </div>
              <div class="text-center" v-else>
                <strong>Você completou {{ courseProgress }}% deste curso.<br /></strong>
                Conclua o curso para obter seu certificado!
              </div>
            </div>

            <section class="video_play_page">
              <div>
                <p class="m-0 p-0" style="text-align: right">
                  <button
                    class="btn btn-small"
                    :class="{ disabled: !certAvailable || downloading }"
                    @click="downloadCertificate()"
                  >
                    <i class="fa fa-download" />
                    {{ downloading ? "Baixando..." : "Baixar certificado" }}
                  </button>
                </p>
                <p class="mt-2 mb-3">
                  <a href="/cursos" class="link">
                    <i class="fa fa-arrow-left" /> Voltar para os cursos</a
                  >
                </p>
                <div
                  class="d-flex"
                  style="flex-wrap: wrap; gap: 15px; align-items: center"
                >
                  <h1 class="video-title class mb-0">
                    {{ course.title }}
                    <span
                      class="text-muted text-primary mt-2"
                      style="
                        display: block;
                        background: rgba(127, 207, 211, 0.4);
                        padding: 10px;
                      "
                      >{{ classObj.title }}</span
                    >
                  </h1>
                </div>
              </div>
              <div class="row gy-3 mt-0">
                <div class="col-lg-8" v-if="!classObj.locked">
                  <div class="video-container" v-if="this.course.plan !== 'Free'">
                    <video-js
                      id="player"
                      controls
                      controlsList="nodownload"
                      fluid="true"
                      class="video-js vjs-theme-city vjs-big-play-centered"
                    >
                      <source
                        x-src="http://sample.vodobox.net/skate_phantom_flex_4k/skate_phantom_flex_4k.m3u8"
                        :src="getCourseClassURL(this.course, this.classObj)"
                        type="application/x-mpegURL"
                        data-setup='{ "playbackRates": [0.5, 1, 1.5, 2] }'
                      />
                    </video-js>
                  </div>

                  <div
                    class="iframe-embed-wrapper iframe-embed-responsive-16by9"
                    v-else-if="this.course.plan === 'Free'"
                  >
                    <iframe
                      id="iframe-embed"
                      class="iframe-embed"
                      width="100%"
                      height="auto"
                      title="YouTube video player"
                      frameborder="0"
                      loading="lazy"
                      :src="this.classObj.config.path + '?version=3&enablejsapi=1'"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;"
                      allowfullscreen
                    ></iframe>
                  </div>

                  <div
                    style="text-align: right"
                    class="class-completion mt-3 mb-0"
                    @click="toggleClassCompletion(classObj, !classObj.completed, true)"
                  >
                    <div style="background: #fff" v-if="!classObj.completed">
                      <i class="fa-regular fa-square"></i>
                      <span style="margin-left: 5px">Marcar como visto</span>
                    </div>

                    <div class="class-completion complete" v-else>
                      <i class="fa-solid fa-check-square"></i>
                      <span style="margin-left: 5px">Marcar como visto</span>
                    </div>
                  </div>

                  <div class="mt-0">
                    <div class="video-details mt-3">
                      <div
                        v-if="!classObj.locked"
                        class="d-flex mb-2"
                        style="
                          font-size: 14.2px;
                          gap: 20px;
                          flex-wrap: wrap;
                          align-items: center;
                        "
                      >
                        <span class="fw-bold">{{
                          formatPlural(classObj.views, "visualização", "visualizações")
                        }}</span>
                        <div
                          class="d-flex btn btn-small liked"
                          style="align-items: center; cursor: pointer"
                          v-if="classObj.liked"
                          @click="unlikeClass()"
                        >
                          <span
                            >{{ classObj.likes }}
                            <i
                              class="fa-solid fa-thumbs-up"
                              style="font-size: 20px; margin-top: -4.8px"
                            ></i
                          ></span>
                        </div>
                        <div
                          class="d-flex btn btn-small"
                          style="align-items: center; cursor: pointer"
                          v-else
                          @click="likeClass()"
                        >
                          <span
                            >{{ classObj.likes }}
                            <i
                              class="fa-regular fa-thumbs-up"
                              style="font-size: 20px; margin-top: -4.8px"
                            ></i
                          ></span>
                        </div>
                      </div>
                      <div class="wrap-box2">
                        <p class="break-word break-line" style="font-size: 14.2px">
                          {{ classObj.description }}
                        </p>
                        <!-- <label></label> -->
                      </div>
                      <div
                        class="mt-3 mb-2"
                        v-if="
                          !classObj.locked && classObj.config && classObj.config.links
                        "
                      >
                        <h2>Links:</h2>
                        <ul class="mt-2">
                          <li v-for="link in classObj.config.links">
                            <a :href="link.src" class="link" target="_blank">{{
                              link.title
                            }}</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-8" v-else>
                  <div class="video-container">
                    <div
                      class="banner"
                      style="
                        width: 100%;
                        line-height: 1.5;
                        font-size: 150%;
                        padding: 20px;
                        position: relative;
                      "
                    >
                      <div class="promo">
                        Disponível em {{ formatDuration(classObj.remainingSeconds) }}.
                      </div>
                      <img :src="getCourseThumbnailURL(course)" />
                    </div>
                  </div>
                  <div class="video-details mt-3">
                    <div class="wrap-box2">
                      <p class="break-word break-line" style="font-size: 14.2px">
                        {{ classObj.description }}
                      </p>
                      <!-- <label></label> -->
                    </div>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="accordion accordion-flush" id="modules" :key="course.id">
                    <div
                      class="accordion-item"
                      v-for="module in course.modules"
                      :key="course.id + '_module_' + module.id"
                    >
                      <h2 class="accordion-header" :id="'module_' + module.id">
                        <button
                          class="accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          :data-bs-target="'#flush-collapse' + module.id"
                          aria-expanded="false"
                          :aria-controls="'#flush-collapse' + module.id"
                        >
                          <span class="d-flex">
                            <span
                              >{{ module.title }}
                              <span class="text-muted"
                                >({{ module.progress }}%)</span
                              ></span
                            >
                          </span>
                        </button>
                      </h2>
                      <div
                        :id="'flush-collapse' + module.id"
                        class="accordion-collapse"
                        :class="{
                          show: classObj.course_module_id === module.id,
                          collapse: classObj.course_module_id !== module.id,
                        }"
                        :aria-labelledby="'module_' + module.id"
                      >
                        <div class="accordion-body">
                          <p
                            class="d-flex nav-link"
                            :class="{ active: c.id === classObj.id }"
                            v-for="c in module.classes"
                            :key="course.id + '_class_' + c.id"
                            @click="goToClass(c)"
                          >
                            <span v-if="c.locked">
                              <i class="fa fa-lock"></i>
                            </span>
                            <span
                              v-else-if="c.completed"
                              @click.stop="toggleClassCompletion(c, !c.completed, true)"
                            >
                              <i class="fa-solid fa-check-circle complete"></i>
                            </span>
                            <span
                              v-else
                              @click.stop="toggleClassCompletion(c, !c.completed, true)"
                            >
                              <i class="fa-regular fa-circle"></i>
                            </span>
                            <span>{{ c.title }}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="mt-4" v-if="!classObj.locked">
                <h3 class="comments-title">
                  Comentários ({{ classObj.active_comments }})
                </h3>
                <hr
                  style="
                    margin-bottom: 0px;
                    border-color: var(--border-color);
                    opacity: 1;
                  "
                  v-if="comments.length > 0"
                />
                <div class="alert alert-warning mt-2" v-if="comments.length === 0">
                  Nenhum comentário foi postado ainda.
                </div>
                <div class="comments" v-else>
                  <div
                    class="box"
                    v-for="comment in comments"
                    :key="comment.id"
                    :id="comment.id"
                  >
                    <img :src="getImageURL(comment.picture)" v-if="comment.picture" />
                    <img class="empty-image" v-else />
                    <div class="c_text_area" style="flex-grow: 1">
                      <p class="name">
                        {{ comment.name ? comment.name : "Virtap"
                        }}<span>{{
                          formatElapsedTime(comment.registration_timestamp)
                        }}</span>
                      </p>
                      <div class="wrap-box short">
                        <p
                          class="break-word dsc"
                          v-html="formatMultilineText(comment.comment)"
                        ></p>
                        <label></label>
                      </div>
                      <p class="under-review" v-if="comment.status === 1">
                        Seu comentário está aguardando moderação e encontra-se invisível
                        no momento.
                      </p>
                      <p class="inactive" v-else-if="comment.status === 3">
                        Seu comentário foi desativado.
                      </p>
                      <div
                        class="mt-2"
                        v-if="!comment.replyShown && comment.children_count > 0"
                      >
                        <button
                          class="btn btn-small bg-secondary"
                          :class="{ disabled: comment.showingReply }"
                          @click="showReply(comment)"
                        >
                          {{ comment.showingReply ? "Carregando..." : "Ver resposta" }}
                        </button>
                        <div
                          class="text-danger mt-2"
                          v-if="!comment.showingReply && comment.replyError"
                          style="font-size: 14px; line-height: 1.6"
                        >
                          <em
                            >Ocorreu um erro ao carregar a resposta.<br />
                            Por favor, tente novamente. Se o problema persistir, atualize
                            a página.</em
                          >
                        </div>
                      </div>
                      <div v-if="comment.replyShown">
                        <hr style="width: 100%; color: #aaa" />
                        <div class="box reply">
                          <img src="/favicon.svg" v-if="comment.picture" />
                          <div class="c_text_area" style="flex-grow: 1">
                            <p class="name">
                              Virtap
                              <span>{{
                                formatElapsedTime(comment.reply.registration_timestamp)
                              }}</span>
                            </p>
                            <p
                              class="break-word dsc"
                              v-html="formatMultilineText(comment.reply.comment)"
                            ></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="page_number mt-0 pt-3" v-if="!classObj.locked && hasMore">
                <button
                  id="fetchMoreComments"
                  class="btn see_more btn-small"
                  :class="{ disabled: loadingMore }"
                  @click="fetchMore()"
                >
                  {{ loadingMore ? "Carregando..." : "Mostrar mais" }}
                </button>
              </div>
              <div
                v-if="loadMoreError"
                class="text-center text-danger mt-2"
                style="font-size: 15px; line-height: 1.6"
              >
                <em>
                  Ocorreu um erro ao carregar comentários.<br />
                  Por favor, tente novamente. Se o problema persistir, atualize a página.
                </em>
              </div>
              <div class="comments-section mt-4" v-if="!classObj.locked">
                <h3 class="comments-title">Adicione um comentário</h3>
                <form id="comment-form" class="comment-form item" onsubmit="return false">
                  <textarea
                    class="form-control"
                    id="txtComment"
                    style="height: 100px; font-size: 14.2px"
                    :disabled="posting"
                    :class="{ disabled: posting }"
                  ></textarea>
                  <em style="display: none; font-size: 12px" class="mt-2 mb-2"></em>
                  <p
                    class="text-danger mt-1"
                    style="display: none; font-size: 14px"
                    data-error
                  ></p>
                  <button
                    type="submit"
                    class="btn btn-medium mt-2 mb-0"
                    @click="addComment()"
                    :disabled="posting"
                    :class="{ disabled: posting }"
                  >
                    {{ posting ? "Enviando..." : "Enviar" }}
                  </button>
                </form>
              </div>
            </section>
          </div>
          <!-- User doesn't have access to the class -->
          <div v-else>
            <!-- Banner : Virtap Club -->
            <div
              class="alert alert-warning mb-3 text-center"
              v-if="course.plan === 'VirtapClub'"
            >
              <i class="fa fa-lock" />
              Curso disponível apenas para membros do <strong>Virtap Club</strong>.

              <div class="row justify-content-center mt-4">
                <div class="col-md-auto col-12">
                  <ul style="text-align: left">
                    <li>
                      <i class="fas fa-check-circle" style="color: #6ab04c"></i>Formação
                      Assistência Virtual
                    </li>
                    <li>
                      <i class="fas fa-check-circle" style="color: #6ab04c"></i>Vídeo
                      aulas exclusivas
                    </li>
                    <li>
                      <i class="fas fa-check-circle" style="color: #6ab04c"></i>Mentorias
                      em grupo
                    </li>
                  </ul>
                </div>
                <div class="col-md-auto col-12">
                  <ul style="text-align: left">
                    <li>
                      <i class="fas fa-check-circle" style="color: #6ab04c"></i>Propostas
                      ilimitadas
                    </li>
                    <li>
                      <i class="fas fa-check-circle" style="color: #6ab04c"></i>Prioridade
                      nas propostas
                    </li>
                    <li>
                      <i class="fas fa-check-circle" style="color: #6ab04c"></i>Comunidade
                      Virtap
                    </li>
                  </ul>
                </div>
              </div>

              <p class="fw-bold fs-6 mt-3 text-center text-primary">12x de R$ 79,90</p>

              <div class="admin-buttons-h mt-3">
                <a class="btn" :href="subscribePage"
                  ><i class="fa fa-shopping-cart" /> Quero assinar!</a
                >
                <a class="btn btn-secondary" :href="virtapClubPage" target="_blank"
                  ><i class="fa fa-plus" /> Conheça todas as vantagens</a
                >
              </div>
            </div>

            <!-- Banner : Formação AExpert -->
            <div
              class="alert alert-warning mb-3 text-center"
              v-else-if="course.id === 'form-ap'"
            >
              Benefícios AExpert...
            </div>

            <section class="video_play_page">
              <div>
                <p class="m-0 p-0" style="text-align: right">
                  <button
                    class="btn btn-small"
                    :class="{ disabled: !certAvailable || downloading }"
                    @click="downloadCertificate()"
                  >
                    <i class="fa fa-download" />
                    {{ downloading ? "Baixando..." : "Baixar certificado" }}
                  </button>
                </p>
                <p class="mt-2 mb-3">
                  <a href="/cursos" class="link">
                    <i class="fa fa-arrow-left" /> Voltar para os cursos</a
                  >
                </p>
                <div
                  class="d-flex"
                  style="flex-wrap: wrap; gap: 15px; align-items: center"
                >
                  <h1 class="video-title class mb-0">
                    {{ course.title }}
                    <span
                      class="text-muted text-primary mt-2"
                      style="
                        display: block;
                        background: rgba(127, 207, 211, 0.4);
                        padding: 10px;
                      "
                      >{{ classObj.title }}</span
                    >
                  </h1>
                </div>
              </div>

              <div class="row gy-3 mt-0">
                <div class="col-lg-8">
                  <div class="video-container">
                    <div
                      class="banner"
                      style="
                        width: 100%;
                        line-height: 1.5;
                        font-size: 150%;
                        padding: 20px;
                        position: relative;
                      "
                    >
                      <!-- CTA - Virtap Club -->
                      <div class="promo" v-if="course.plan === 'VirtapClub'">
                        <strong
                          >Conteúdo disponível apenas para membros do Virtap Club</strong
                        ><br />
                        <div class="admin-buttons-h mt-3">
                          <a class="btn" :href="subscribePage"
                            ><i class="fa fa-shopping-cart" /> Quero assinar!</a
                          >
                        </div>
                      </div>

                      <!-- CTA - Virtap Club -->
                      <div class="promo" v-else-if="course.id === 'form-ap'">
                        <strong
                          >Conteúdo disponível para alunos da Formação AExpert...</strong
                        >
                      </div>

                      <img :src="getCourseThumbnailURL(course)" />
                    </div>
                  </div>

                  <div class="video-details mt-3">
                    <div class="wrap-box2">
                      <p class="break-word break-line" style="font-size: 14.2px">
                        {{ classObj.description }}
                      </p>
                      <!-- <label></label> -->
                    </div>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="accordion accordion-flush" id="modules" :key="course.id">
                    <div
                      class="accordion-item"
                      v-for="module in course.modules"
                      :key="course.id + '_module_' + module.id"
                    >
                      <h2 class="accordion-header" :id="'module_' + module.id">
                        <button
                          class="accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          :data-bs-target="'#flush-collapse' + module.id"
                          aria-expanded="false"
                          :aria-controls="'#flush-collapse' + module.id"
                        >
                          <span class="d-flex">
                            <span
                              >{{ module.title }}
                              <span class="text-muted"
                                >({{ module.progress }}%)</span
                              ></span
                            >
                          </span>
                        </button>
                      </h2>
                      <div
                        :id="'flush-collapse' + module.id"
                        class="accordion-collapse"
                        :class="{
                          show: classObj.course_module_id === module.id,
                          collapse: classObj.course_module_id !== module.id,
                        }"
                        :aria-labelledby="'module_' + module.id"
                      >
                        <div class="accordion-body">
                          <p
                            class="d-flex nav-link"
                            :class="{ active: c.id === classObj.id }"
                            v-for="c in module.classes"
                            :key="course.id + '_class_' + c.id"
                            @click="goToClass(c)"
                          >
                            <span>
                              <i class="fa fa-lock"></i>
                            </span>
                            <span>{{ c.title }}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
        <!-- Course doesn't exist or doesn't have active clases -->
        <div class="center-block" v-else>
          <div>
            <div class="alert alert-danger mb-0 text-center">
              Este curso não está disponível.
              <p class="text-center">
                <a :href="'/cursos'" class="btn mt-2">
                  <i class="fa fa-arrow-left" /> Voltar para os cursos</a
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
function sleep(ms) {
  return new Promise((res) => setTimeout(res, ms));
}

import SideBar from "../SideBar.vue";
import TopBar from "../TopBar.vue";
import AssistantManager from "../../../js/services/assistant.js";
import StringUtils from "../../../js/utils/string.js";
import Config from "../../../../resources/config.js";

const RESULT_COUNT = 10;

export default {
  components: { SideBar, TopBar },

  created() {
    this.$store.commit("setActiveSection", `CoursePage_${this.$route.params.courseId}`);
    this.loadClass();
  },

  data() {
    return {
      course: null,
      module: null,
      classObj: null,
      posting: false,
      downloading: false,
      comments: [],
      loadingMore: false,
      loadMoreError: false,
      hasMore: true,
    };
  },

  computed: {
    loading() {
      return this.$store.state.loading;
    },
    activeUser() {
      return this.$store.state.activeUser;
    },
    freePlan() {
      return this.activeUser.plan === "Free";
    },
    courseProgress() {
      return this.calculateCourseProgress(this.course);
    },
    utmParams() {
      return "utm_source=plataforma&utm_medium=assistentes&utm_campaign=assinatura-virtapclub&utm_content=aula-curso";
    },
    next() {
      return `curso/${this.course.id}/${this.classObj.id}`;
    },
    virtapClubPage() {
      return Config.virtapClubPage + `?${this.utmParams}&next=${this.next}`;
    },
    subscribePage() {
      return (
        Config.subscribePage + `?plano=VirtapClub&${this.utmParams}&next=${this.next}`
      );
    },
    certAvailable() {
      if (this.course.certificateReleaseTimestamp) {
        return false;
      }
      if (this.calculateCourseProgress(this.course) === 100) {
        return true;
      } else if (this.activeUser.cert_av && this.course.id === "form-av") {
        return true;
      } else if (this.activeUser.cert_ap && this.course.id === "form-ap") {
        return true;
      }
      return false;
    },
  },

  methods: {
    async loadClass() {
      let $ctx = this;
      this.$store.commit("setLoading", true);
      try {
        let response = await AssistantManager.getClass(
          this.$route.params.courseId,
          this.$route.params.classId,
          RESULT_COUNT
        );
        response.comments.forEach((c) => {
          c.replyShown = false;
          c.showingReply = false;
          c.reply = null;
          c.replyError = false;
        });
        this.course = response.course;
        this.module = response.module;
        this.classObj = response.class;
        this.comments = response.comments;
        this.hasMore = this.comments.length >= RESULT_COUNT;
        this.updateStats();
        this.$store.commit("setActiveUser", response.assistant);
        this.$store.commit("setLoading", false);
        this.applyTruncation();

        if (!this.course) {
          this.$store.commit("setActiveSection", `CourseNotFoundPage`);
        }
        if (!this.course || !this.course.config) {
          return;
        }

        if (this.classObj && this.classObj.locked) {
          let $ctx = this;
          let interval = setInterval(() => {
            if ($ctx.classObj.remainingSeconds === 0) {
              clearInterval(interval);
              location.reload();
              return;
            }
            $ctx.classObj.remainingSeconds--;
          }, 1000);
          return;
        }

        this.$nextTick(() => {
          $ctx.adjustVideo();
        });
      } catch (error) {
        this.handleAPIError(
          error,
          "curso/" + this.$route.params.courseId + "/" + this.$route.params.classId
        );
      }
    },
    adjustVideo() {
      let $ctx = this;
      if (this.classObj && !this.classObj.locked) {
        if (this.course.plan !== "Free") {
          let player = videojs("player", {
            playbackRates: [0.5, 1, 1.5, 2],
            html5: {
              hls: {
                withCredentials: true,
              },
            },
          });

          player.ready(function () {
            player.on("ended", async function () {
              $ctx.toggleClassCompletion($ctx.classObj, true, false);
            });

            player.play();
          });
        } else {
          let player;
          window.onYouTubeIframeAPIReady = function () {
            player = new YT.Player("iframe-embed", {
              events: {
                onReady: function (event) {
                  player.playVideo();
                },
                onStateChange: async function (event) {
                  if (event.data === 0) {
                    $ctx.toggleClassCompletion($ctx.classObj, true, false);
                  }
                },
              },
            });
          };

          var tag = document.createElement("script");
          tag.src = "https://www.youtube.com/iframe_api";
          var firstScriptTag = document.getElementsByTagName("script")[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }
      }
    },
    updateStats() {
      if (this.course) {
        for (let m of this.course.modules) {
          let s = 0;
          for (let c of m.classes) {
            if (c.completed) {
              s++;
            }
          }
          m.progress = Number((s / m.classes.length) * 100.0).toFixed(0);
        }
      }
    },

    goToClass(classObj) {
      location.href = "/curso/" + this.course.id + "/" + classObj.id;
    },

    async toggleClassCompletion(classInstance, flag, showError) {
      let $ctx = this;
      try {
        classInstance.completed = flag;
        for (let m of $ctx.course.modules) {
          for (let c of m.classes) {
            if (c.id === classInstance.id) {
              c.completed = flag;
            }
          }
        }
        if (classInstance.id === $ctx.classObj.id) {
          $ctx.classObj.completed = flag;
        }
        $ctx.updateStats();
        await AssistantManager.completeClass($ctx.course.id, classInstance.id, flag);
      } catch (err) {
        console.log("Failure marking class as completed.", classInstance, err);
      }
    },

    async addComment() {
      let $ctx = this;
      let $item = $("#txtComment").closest(".item");

      this.posting = true;

      try {
        let commentDetails = {
          class_id: this.classObj.id,
          comment: $("#txtComment").val(),
        };

        $item.removeClass("error");
        $item.find("em").hide();
        $item.find("[data-error]").hide();

        if (
          StringUtils.isEmpty(commentDetails.comment) ||
          commentDetails.comment.length < 10
        ) {
          $item.addClass("error");
          $item
            .find("em")
            .text("Por favor, informe um cometário com pelo menos 10 caracteres.")
            .show();
          $("#txtComment").focus();
          return;
        }

        let response = await AssistantManager.addClassComment(
          this.course.id,
          commentDetails
        );
        this.comments.unshift(response.comment);
        $("#txtComment").val("");
      } catch (error) {
        console.log(error);
        if (error.status === 401) {
          $item.find("[data-error]").html($ctx.buildSessionLink()).show();
        } else {
          $item
            .find("[data-error]")
            .html(
              $ctx.formatMultilineText(
                "Ocorreu um erro postar o comentário.\nPor favor, tente novamente. Se o problema persistir, atualize a página."
              )
            )
            .show();
        }
      } finally {
        this.posting = false;
      }
    },

    test() {
      alert("s");
    },
    async showReply(comment) {
      comment.showingReply = true;
      comment.replyError = false;

      try {
        let response = await AssistantManager.getClassCommentReply(
          this.course.id,
          this.classObj.id,
          comment.id
        );
        if (response.comments.length > 0) {
          comment.reply = response.comments[0];
          comment.replyShown = true;
        }
      } catch (err) {
        console.log(err);
        comment.replyError = true;
      } finally {
        comment.showingReply = false;
      }
    },

    async fetchMore() {
      let ctx = this;
      ctx.loadingMore = true;
      let lastComment = null;
      if (this.comments && this.comments.length > 0) {
        lastComment = this.comments[this.comments.length - 1];
      }

      ctx.loadMoreError = false;

      try {
        let response = await AssistantManager.getClassComments(
          ctx.course.id,
          ctx.classObj.id,
          lastComment,
          RESULT_COUNT
        );

        this.comments = this.comments.concat(response.comments);
        if (response.comments.length < RESULT_COUNT) {
          this.hasMore = false;
        }

        ctx.$nextTick(() => {
          ctx.applyTruncation(() => {
            if (response.comments.length > 0) {
              let card = $(".comments")
                .find("#" + response.comments[0].id)
                .get(0);
              let scrollDiv = card.offsetTop - 10;
              window.scrollTo({ top: scrollDiv, behavior: "smooth" });
            }
          });
        });
      } catch (err) {
        console.log(err);
        ctx.loadMoreError = true;
      } finally {
        ctx.loadingMore = false;
      }
    },

    async likeClass() {
      try {
        this.classObj.likes++;
        this.classObj.liked = true;
        await AssistantManager.likeClass(this.course.id, this.classObj.id);
      } catch (err) {
        console.log(err);
      }
    },

    async unlikeClass() {
      try {
        this.classObj.likes--;
        this.classObj.liked = false;
        await AssistantManager.unlikeClass(this.course.id, this.classObj.id);
      } catch (err) {
        console.log(err);
      }
    },

    formatCourseCertificateReleaseDate(timestamp) {
      const date = new Date(timestamp);

      const formatter = new Intl.DateTimeFormat("pt-BR", {
        timeZone: "America/Sao_Paulo",
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });

      const parts = formatter.formatToParts(date);

      const day = parts.find((p) => p.type === "day").value;
      const month = parts.find((p) => p.type === "month").value;
      const year = parts.find((p) => p.type === "year").value;
      const hour = parts.find((p) => p.type === "hour").value;
      const minute = parts.find((p) => p.type === "minute").value;

      // Return string in desired format
      return `${day}/${month}/${year} às ${hour}:${minute} (Horário de Brasília)`;
    },

    async downloadCertificate() {
      if (this.downloading) {
        return;
      }

      if (!this.certAvailable) {
        if (this.course.certificateReleaseTimestamp) {
          this.showError(
            `O certificado deste curso ficará disponível a partir de ${this.formatCourseCertificateReleaseDate(
              this.course.certificateReleaseTimestamp
            )}.\n\nTente novamente mais tarde!`
          );
          return;
        }

        this.showError(
          "Seu certificado ainda não está disponível.\n\nPor favor, conclua todas as aulas e tente novamente."
        );
        return;
      }

      this.downloading = true;

      try {
        let certificate;
        if (this.course.id === "intro-av") {
          certificate = await AssistantManager.claimIntroAVCertificate();
          this.downloadAndRedirect(
            certificate,
            "certificado-intro-av.jpeg",
            Config.introAVCompletePage +
              "?&utm_source=plataforma&utm_medium=assistentes&utm_campaign=assinatura-virtapclub&utm_content=certificado-intro-av"
          );
        } else if (this.course.id === "form-av") {
          certificate = await AssistantManager.claimFormAVCertificate();
          this.download(certificate, "certificado-formacao-av.jpeg");
        } else if (this.course.id === "form-ap") {
          certificate = await AssistantManager.claimFormAPCertificate();
          this.download(certificate, "certificado-formacao-ap.jpeg");
        } else {
          throw new Error("Unsupported course:" + this.course.id);
        }
      } catch (err) {
        if (err && err.errorCode === "NO_CERTIFICATE_AVAILABLE") {
          this.showError(
            "Seu certificado ainda não está disponível.\n\nPor favor, conclua todas as aulas e tente novamente."
          );
          return;
        }
        console.log(err);
        this.showError(
          "Não foi possível baixar seu certificado.\n\nPor favor tente novamente. Se o problema persistir, atualize a página."
        );
      } finally {
        this.downloading = false;
      }
    },
  },
};
</script>
